import { Card, CardContent } from "@/components/ui/card"

const termsContent = [
  {
    title: "Agreement to Terms",
    content: [
      "By accessing our services, you agree to be bound by these Terms",
      "If you disagree with any part of the terms, you may not access our services",
      "We reserve the right to modify these terms at any time",
      "Continued use of our platform following any changes constitutes acceptance of those changes"
    ]
  },
  {
    title: "Use of Services",
    content: [
      "Services must be used in accordance with all applicable laws and regulations",
      "You are responsible for maintaining the confidentiality of your account",
      "You agree not to use our services for unauthorized or illegal purposes",
      "We reserve the right to terminate accounts for misconduct"
    ]
  },
  {
    title: "Financial Services",
    content: [
      "Investment advice is provided for informational purposes only",
      "Past performance is not indicative of future results",
      "All investments carry risk and may lose value",
      "Users should conduct their own due diligence before making investment decisions"
    ]
  },
  {
    title: "Intellectual Property",
    content: [
      "All content on our platform is protected by copyright and other IP rights",
      "Users may not reproduce or distribute our content without permission",
      "We respect the intellectual property rights of others",
      "Users must have rights to any content they submit to our platform"
    ]
  },
  {
    title: "Limitation of Liability",
    content: [
      "Services are provided 'as is' without any warranties",
      "We are not liable for any indirect, incidental, or consequential damages",
      "Our liability is limited to the amount paid for our services",
      "Some jurisdictions do not allow liability limitations, so these may not apply"
    ]
  },
  {
    title: "Dispute Resolution",
    content: [
      "Any disputes will be resolved through binding arbitration",
      "Proceedings will be conducted in New York, NY",
      "Class action waiver applies to all disputes",
      "Users have the right to opt out of arbitration within 30 days"
    ]
  }
]

export function TermsPage() {
  return (
    <div className="space-y-24 py-24">
      {/* Hero Section */}
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-4xl font-bold tracking-tight mb-6">
            Terms of Service
          </h1>
          <p className="text-lg text-neutral-600 dark:text-neutral-400">
            Please read these terms carefully before using our services.
          </p>
          <p className="text-sm text-neutral-600 dark:text-neutral-400 mt-4">
            Last updated: {new Date().toLocaleDateString()}
          </p>
        </div>
      </div>

      {/* Content Sections */}
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto space-y-8">
          {termsContent.map((section) => (
            <Card key={section.title}>
              <CardContent className="p-6">
                <h2 className="text-2xl font-semibold mb-4">{section.title}</h2>
                <ul className="space-y-3">
                  {section.content.map((item) => (
                    <li 
                      key={item} 
                      className="text-neutral-600 dark:text-neutral-400 flex items-start"
                    >
                      <span className="mr-2">•</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          ))}

          {/* Contact Section */}
          <Card>
            <CardContent className="p-6">
              <h2 className="text-2xl font-semibold mb-4">Questions About our Terms?</h2>
              <p className="text-neutral-600 dark:text-neutral-400">
                If you have any questions about these Terms of Service, please contact our legal team at:
              </p>
              <div className="mt-4">
                <p className="text-neutral-600 dark:text-neutral-400">Email: legal@polymath.com</p>
                <p className="text-neutral-600 dark:text-neutral-400">Address: 100 Wall Street, New York, NY 10005</p>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  )
} 